import { render, staticRenderFns } from "./translation-manager-row.vue?vue&type=template&id=36812274&scoped=true"
import script from "./translation-manager-row.vue?vue&type=script&lang=js"
export * from "./translation-manager-row.vue?vue&type=script&lang=js"
import style0 from "./translation-manager-row.vue?vue&type=style&index=0&id=36812274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36812274",
  null
  
)

export default component.exports